<!--
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-03 11:07:46
 * @Description: Mines 游戏 game-coat layout02
-->
<template>
    <NuxtLayout name="game-coat"
        :topHeight="'690px'"
    >
        <template #bgImg>
            <img :src="isShowingMobileBG ? bgImage02 : bgImage01" />
        </template>
        <template #panel-left>
            <CasinoBetOptionSection
                class=""
                v-model:bet-amount-modal-value="oForm.amount"
                v-model:is-submiting="disabledGamePanel"
                :isAuto="isAutoMode"
                @change-mode="toChangeMode"
            >
                <template #bet-button>
                    <ButtonThe2RowsButton
                        narrow 
                        class="h-full"
                        full-width
                        size="lg"
                        @click="clickOnBetBtn()"
                        :disabled="disabledBetBtn"
                        :dismark="disabledBetBtn"
                        v-click-and-rest
                    >
                        {{ aBetBtnWords[0] }}
                        <template #secondRow v-if="aBetBtnWords[1]" >
                            <span :class="isAutoMode ? 'inline-block mt-1' : ``">
                                {{ aBetBtnWords[1] }}
                            </span>
                        </template>
                    </ButtonThe2RowsButton>
                </template>
            </CasinoBetOptionSection>
            <!-- ↓ 游戏面板 -->
            <div class="mines-control disabled-by-self"
                mode="manual"
            >
                <p class="mines-control__range-label">
                    {{$t('mines.MinesAmount')}}
                </p>
                <div class="mines-control__wrap">
                    <div class="mines-control__range-block disabled-by-top">
                        <div class="mines-control__range-help">
                            <img class="mines-control__img" src="./img/label-bomb.webp" alt="Mines">
                            <p class="mines-control__value">
                                <ClientOnly>{{ round.count }}</ClientOnly>
                            </p>
                        </div>
                        <div class="range mines-control__mines-count"
                            :style="{
                                '--height': '7px',
                                '--knob-size': '16px',
                                '--rail-color': 'rgba(17, 25, 35, 0.8)',
                                '--fill-color': '#2283f6',
                                '--knob-color': '#2283f6',
                                '--percent': `${(round.count-1) / 23 * 100}%`, 
                            }"
                        >   
                            <input class="range__input"
                                type="range"
                                step="1"
                                min="1"
                                max="24"
                                v-model="round.count"
                                :disabled="disabledRanger"
                            >
                        </div>
                    </div>
                    <!-- 左右分界 -->
                    <!-- ↓ 机选按钮 -->
                    <div class="mines-control__auto-pick">
                        <ButtonThe3DButton color="blue" size="lg"
                            fullWidth
                            v-click-and-rest
                            @click="pickAutomatically"
                            :disabled="bDisableAutoPick"
                            :dismark="!!bDisableAutoPick"
                        >
                            {{ $t('mines.AutoPick') }}
                            <!-- ↓测试标识 -->
                            <!-- {{ iJoinMark }} -->
                        </ButtonThe3DButton>
                    </div>
                </div>
            </div>
        </template>
        <!--
            左
            右
            分
            界
        -->
        <!-- ↓ 补一个条件恒真的 v-if=myTrue 用于消除发布后原因不明的报错 -->
        <template #playing-area-right >
            <div class="game-layout__game-inner mt-1"
                :style="{
                    height: isShowingMobileBG ? 'auto' : '507px',
                    width: '100%',
                }"
            >
                <div class="game-wrapper"
                    :class="{
                        'game-wrapper--result': oGameResult.iShowResult == 1,
                    }"
                >
                    <!-- ↓ 重要容器 --> 
                    <section
                        style="transform: scale(1);"
                        class="mines-board"
                        :class="{'mines-board--no-animate': !isShowAnimation}"
                    >
                        <!-- ↓ 移动端专用内容 -->
                        <div class="mines-board__info"
                            v-if="isShowingMobileBG"
                        >
                            <div class="mines-board__info-diamond">
                                <img class="mines-board__info-img" src="./img/label-diamond.webp" >
                                <ClientOnly>{{ 25 - count }}</ClientOnly>
                            </div>
                            <!-- ★ -->
                            <div class="rtp">
                                <CasinoWidgetRTP
                                    type="new"
                                    style="margin-top: 0px"
                                />
                            </div>
                            <!-- ★ -->
                            <div class="mines-board__info-bomb">
                                <ClientOnly>{{ count }}</ClientOnly>
                                <img class="mines-board__info-img" src="./img/label-bomb.webp" >
                            </div>
                        </div>
                        <!-- ↑ 移动端内容 -->
                        <div class="bg-steps">
                            <img src="./img/footstep.png" style="display: none;">
                            <img v-if="!isShowingMobileBG"
                                class="bg-steps__bg"
                                src="./img/mines-bg-02.webp"
                            >
                            <canvas class="bg-steps__bg"
                                ref="canvas01"
                                width="1296"
                                height="990"
                            ></canvas>
                        </div>
                        <!-- ↓ 左侧，钻石（PC端内容） -->
                        <div v-if="!isShowingMobileBG"
                            class="mines-board__panel mines-board__panel--left"
                        >
                            <div class="mines-board__panel-top mines-board__panel-diamond">
                                <img class="mines-board__diamond-img" src="./img/label-diamond.webp" />
                            </div>
                            <p class="mines-board__panel-value">
                                <ClientOnly>{{ 25 - count }}</ClientOnly>
                            </p>
                        </div>
                        <!-- ↑ 左侧，钻石（PC端内容） -->
                        <!-- ↓ ✨ 用户核心选择区 -->
                        <section class="board"
                            abcclass="{disabled: 0}"
                        >
                            <img class="board__bg" src="./img/board-bg.png" >
                            <ClientOnly>
                                <button v-for="(oCurBtn, iBtnIndex) of aButList"
                                    :class="{...(oGlobal.client ? oCurBtn.oClass : {})}"
                                    :key="iBtnIndex"
                                    @click="pickManually(oCurBtn)"
                                    :disabled="oGlobal.client && oCurBtn.disabled || isDigging"
                                >
                                    <!-- ↓ 爆炸时此元素不可见 display: none -->
                                    <div class="board__card-wrap">
                                        <img class="board__card-image"
                                            v-if="oCurBtn.sPicSrc"
                                            :src="oCurBtn.sPicSrc"
                                        />
                                    </div>
                                </button>
                            </ClientOnly>
                        </section>
                        <!-- ↑ ✨ 用户核心选择区 -->
                        <!-- ↓ 右侧，地雷数量（PC端内容） -->
                        <div v-if="!isShowingMobileBG"
                            class="mines-board__panel mines-board__panel--right"
                        >
                            <div class="mines-board__panel-top mines-board__panel-bomb">
                                <img class="mines-board__bomb-img" src="./img/label-bomb.webp"/>
                            </div>
                            <p class="mines-board__panel-value">
                                <ClientOnly>{{ count }}</ClientOnly>
                            </p>
                        </div>
                        <!-- ↑ 右侧，地雷数量（PC端内容） -->
                        <!-- ↓ 返现列表 -->
                        <div class="coefficients">
                            <button class="coefficients__btn coefficients__btn_prev"
                                :class="{'coefficients__btn--disabled': slide <= 0}"
                                @click="prev"
                            >
                                <img class="coefficients__btn-img" src="./img/coeff-btn.webp">
                            </button>
                            <!-- ↑左侧按钮 -->
                            <!-- ↓列表 -->
                            <div class="coefficients__outer">
                                <div class="coefficients__inner"
                                    :style="{
                                        transform: `translateX(-${ 100 / totalSlides * slide }%)`,
                                    }"
                                    :class="{
                                        [`_${totalSlides}`]: true,
                                    }"
                                >
                                    <!-- ↓ 某一页 -->
                                    <div class="coefficient-slide"
                                        v-for="(aPage, i01) of aSlides"
                                        :key="i01"
                                    >
                                        <ul class="coefficient-items" >
                                            <li class="coefficient-item"
                                                v-for="(oItem, i02) of aPage"
                                                :class="{active: oItem.won}"
                                                :key="`${i01}-${i02}`"
                                            >
                                                <div class="coefficient-item__hint">
                                                    {{ oItem.idx }}
                                                    <img v-if="oItem.won"
                                                        class="coefficient-item__hint-image"
                                                        src="./img/coeff-stone-active.webp" 
                                                    >
                                                    <img v-else
                                                        class="coefficient-item__hint-image"
                                                        src="./img/coeff-stone.webp" 
                                                    >
                                                </div>
                                                <span class="coefficient-item__label">
                                                    {{ oItem.multiple }}x
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- ↑ 某一页 -->
                                </div>
                            </div>
                            <!-- ↑列表 -->
                            <!-- ↓右侧按钮 -->
                            <button class="coefficients__btn coefficients__btn_next"
                                :class="{'coefficients__btn--disabled': slide >= totalSlides-1}"
                                @click="next"
                            >
                                <img class="coefficients__btn-img" src="./img/coeff-btn.webp">
                            </button>
                        </div>
                    </section>
                    <!-- 
                        ↑ 游戏区
                        ↓ 游戏结果
                    -->
                    <section class="mines-result"
                        v-if="oGameResult.iShowResult > 0"
                        :class="{
                            'mines-result--show': oGameResult.iShowResult == 1,
                            'mines-result--hide': oGameResult.iShowResult == 2,
                        }"
                    >
                        <!-- ↓ 普通提现 -->
                        <template v-if="!oGameResult.bFoundAll">
                            <div class="mines-result__cashout-wrap">
                                <img class="mines-result__cashout-bg" src="./img/static-bg.webp" />
                                <img class="mines-result__decor mines-result__decor-1" src="./img/decor-1.png" />
                                <img class="mines-result__decor mines-result__decor-2" src="./img/decor-2.png" />
                                <img class="mines-result__decor mines-result__decor-3" src="./img/decor-3.png" />
                                <img class="mines-result__decor mines-result__decor-4" src="./img/decor-4.png" />
                                <img class="mines-result__decor mines-result__decor-5" src="./img/decor-5.png" />
                                <img class="mines-result__decor mines-result__decor-6" src="./img/decor-6.png" />
                                <img class="mines-result__decor mines-result__decor-7" src="./img/decor-7.png" />
                                <img class="mines-result__decor mines-result__decor-8" src="./img/decor-8.png" />
                                <img class="mines-result__decor mines-result__decor-9" src="./img/decor-9.png" />
                                <img class="mines-result__decor mines-result__decor-10" src="./img/decor-10.png" />
                                <img class="mines-result__decor mines-result__decor-11" src="./img/decor-11.png" />
                                <!-- ↑图 -->
                                <div class="mines-result__cashout-block">
                                    <p class="mines-result__cashout-multi">
                                        {{ getFixed(iMultipleHasWon) }}x
                                    </p>
                                    <!-- 上下分界 -->
                                    <div class="mines-result__cashout-amount">
                                        <span class="currency">
                                            <CurrentCoin class="currency__icon" size="26px" ></CurrentCoin>
                                            &nbsp;
                                            <span style="font-size: 18px;">
                                                <span style="color: #1BB83D" class="font-digits">
                                                    <!-- {{123456}}<span style="color: #1BB83D">{{'0000'}}</span> -->
                                                    {{ fMoneyCashOut }}
                                                </span>
                                            </span>
                                        </span>
                                        <!-- ↑金额，↓币种 -->
                                        <span class="mines-result__cashout-currency">
                                            {{ oUserStore.oNowCurrency.currencyName.toUpperCase()}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!--
                            ↑ 用户提现
                            ↓ 大赢
                        -->
                        <template v-else>
                            <div class="mines-result__win-wrap">
                                <img class="mines-result__win-bg" src="./img/static-bg-cloud.png" >
                                <img class="mines-result__win-text" src="./img/win-text.png" >
                                <div class="mines-result__win-block">
                                    <div class="mines-result__win-multi">
                                        {{iMultipleHasWon}}x
                                    </div>
                                    <!-- 左右分界，↑倍数 ↓金额 -->
                                    <span class="currency">
                                        <CurrentCoin class="currency__icon" size="26px" ></CurrentCoin>
                                        <span style="font-size: 19px;">
                                            <span style="color: #1BB83D" class="font-digits">
                                                <!-- 123456<span style="color: #1BB83D">0000</span> -->
                                                {{ fMoneyCashOut + ' ' + oUserStore.oNowCurrency.currencyName.toUpperCase()}}
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </template>
                    </section>
                    <!-- ↑ 游戏结果 -->
                </div>
            </div>
        </template>
    </NuxtLayout>
    <!-- ↓ 自动下注的输入面板（弹窗） -->
    <CasinoAutoSection
        :is-fast="false"
        :is-submiting="oForm.isSubmiting"
        :is-auto="isAutoMode"
        v-model:amount="oForm.amount"
        :ref="el => oAutoDialog=el"
        :gameName="'minesGame'" 
    />
</template>


<script lang='ts'>
import bgImage01 from './img/mines-bg.webp';
import bgImage02 from './img/mines-bg-02.webp';
import imgBomb from './img/label-bomb.webp';
import imgDiamond from './img/label-diamond.webp';
// ------- ↑图 --------------------------------------------
import music_music_loop from '@/assets/mp3/mime/music_loop.mp3';
import music_plac_bet from '@/assets/mp3/mime/place-bet.mp3';
import music_autoPlay from '@/assets/mp3/mime/autoplay.mp3';
import music_diamond from '@/assets/mp3/mime/diamond.mp3';
import music_explosion from '@/assets/mp3/mime/explosion.mp3';
import music_win from '@/assets/mp3/mime/win.mp3';
// ------- ↑音乐 --------------------------------------------
import useSettingsStore from '@/stores/settings/index';
import useGlobalStore from '@/stores/global';
import {useUserStore} from '@/stores/user';
import {useJoinStateStore} from '@/stores/cansino/joinState';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
// ------- ↑ stores --------------------------------------------
import type { FormObject } from '@/common/js/bettingToolkit/index';
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { useAutoBetToolKit } from '@/common/js/bettingToolkit/auto';
import {oMethods, arr0to24} from './js/mines-methods.js';
import { showTips4BadAmountIfNeeded } from '@/common/js/betHelper';

export default defineComponent({
    name: 'minesGame',
    data() {
        const oMusic = import.meta.client && new MusicControler({
            bg: {
                src: music_music_loop,
                loop: true,
                isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
            },
            placBet:{ src: music_plac_bet },
            autoPlay:{ src: music_autoPlay },
            diamond:{ src: music_diamond },
            explosion:{ src: music_explosion },
            win:{ src: music_win },
        } as any);
        const oForm: FormObject = ({
            amount: 0,
            isSubmiting: false, // 状态为 false 则停止自动下注
        });
        const oBorrowed = {
            round: {
                prediction: [], // 用户的选择 [0,2,4]
                count: 4, // 指定炸弹数量 1-24 ，原版默认为 4 
                fields: [], // 炸弹位置，数组成员值的可能性为：0-24 
                status: 0, // ← 借得后没有使用它
            },
            slide: 0, // check() 方法会修改此值 
            iLostOn: -1, // 踩雷位置 
        };
        const oInterface = { // 界面相关
            bgImage01,
            bgImage02,
            imgBomb,
            imgDiamond,
            sExplosiveClassName: '',
            timer4CloseResult: null,
            oAutoDialog: null,
        };
        // ↓ 游戏结果
        const oGameResult = {
            iShowResult: 0,
            bFoundAll: false, // 是否大赢，即找到了所有钻石
            win: true,
            winAmount: 0,
        };
        const oOthers = {
            oMusic, // 音乐
            oGlobal: useGlobalStore(),
            oUserStore: useUserStore(),
            oSettingsStore: useSettingsStore(),
            oJoinStateStore: useJoinStateStore(),
            autoOption: useAutoOptionStore(),
            plan2StopAutoBetting: false, // 是否计划关闭自动模式的标记 
            oStepsAnim: {}, // 动画实例
        };
        return {
            myTrue: true, // 特殊值 
            iJoinMark: 0, // 0-1-2 = 未开始/进行中/已结束
            isGameing: false, // 游戏进行中
            oForm,
            isAutoMode: false,
            oGameResult,
            isDigging: false, // 为 true 时禁用舞台，防止用户连点 
            oLastRoundGame: {hash: ''}, // 上局游戏
            ...oBorrowed,
            ...oOthers,
            ...oInterface,
        };
    },
    computed: {
        disabledGamePanel:{
            get(){
                const bResult = (
                    this.oForm.isSubmiting
                    || this.iJoinMark == 1
                );
                return bResult;
            },
            set(newVal){
                console.log("newVal", newVal);
            },
        },
        // ↓ 背景变化标记
        isShowingMobileBG(){
            const {innerWidth} = this.oGlobal;
            if (!innerWidth){ 
                return true; // 尚未加载到宽度，优先推定为移动设备 
            }
            return innerWidth <= 590;
        },
        // ↓ 是否显示动画
        isShowAnimation() {
            if (!this.oGlobal.client) return false;
            const {animation} = this.oSettingsStore.inhouseGames.mines;
            return !!animation;
        },
        // ↓ 当前炸弹数量对应的兑奖表
        // ↓ 表示不同钻石数量对应的倍数
        coeffs() {
            let idx = this.round.count;
            if (!idx){
                console.error('没有 count 值'); // 通常不会到这里，
                idx = 1;
            }
            const {coefficients} = this.oJoinStateStore.config;
            const arr = coefficients?.[idx] || []; 
            return arr;
        },
        // ↓ 表示返现信息需要陈列 x 页
        totalSlides() {
            if (!this.oGlobal.client) return 1;
            const iLen = (this.coeffs || []).length;
            const iPages = Math.ceil(iLen / 6);
            return iPages;
        },
        // ↓ 找到的钻石，数组 
        aDiaondFound() {
            if (this.iLostOn == -1){
                return this.prediction;
            }
            return this.prediction.filter(iDiamonPos => {
                return iDiamonPos != this.iLostOn;
            });
        },
        // ↓ 返现信息（下方条形） 
        aSlides(){
            if (
                !this.oGlobal.client
                || (this.totalSlides > 0 == false)
            ) {
                return []; 
            }
            let aPages = Array(this.totalSlides).fill(0);
            const iDiaondFound = this.aDiaondFound.length;
            aPages = aPages.map((cur, i01)=>{
                const iStart = i01 * 6;
                let thisArr = this.coeffs.slice(iStart, iStart + 6);
                thisArr = thisArr.map((thisOne, i02) => {
                    const iGlobalIndex = iStart + i02 + 1;
                    const iTailLong = thisOne < 10 ? 2 : 1;
                    return {
                        idx: iGlobalIndex,
                        multiple: getFixed(thisOne, iTailLong),
                        won: iGlobalIndex === iDiaondFound,
                    };
                });
                return thisArr;
            });
            return aPages;
        },
        // ↓ 赢钱倍数
        iMultipleHasWon(){
            const iQtyHasChosen = this.round.prediction.length;
            if (!iQtyHasChosen) return 0;
            return this.coeffs[iQtyHasChosen - 1];
        },
        prediction() {
            return this.round.prediction;
        },
        fields() {
            return this.round.fields;
        },
        status() {
            return this.round.status;
        },
        count() {
            // ↓ 防止返回零或空引起报错
            const iResult = Number(this.round.count || 1);
            return iResult; 
        },
        // ↓ 按钮数组
        aButList(){
            // 接口返回的雷区 fields: [10, 14, 0] 
            // 说明雷区编号从0开始 
            const aResult = arr0to24.map((iNumber) => {
                return this.getButtonClassName(iNumber);
            });
            if (0 && import.meta.dev){
                const aPrint = aResult.map(cur=>{
                    const oNewOne = {
                        iNumber: cur.iNumber,
                        oClass: JSON.stringify(cur.oClass),
                    }
                    return oNewOne;
                })
                console.table(aPrint);
            }
            return aResult;
        },
        // ↓ 提现金额
        fMoneyCashOut(){
            const {prediction, oUserStore, iJoinMark, oGameResult} = this;
            const winAmount = oGameResult.winAmount;
            const showCashOutValeu = (
                prediction.length &&
                winAmount > 0
            );
            if (!showCashOutValeu) return 0;
            const sAmount = getFixed(winAmount, 2);
            return Number(sAmount);
        },
        // ↓计算“机选按钮” 的禁用状态 
        bDisableAutoPick(){
            if (!this.isAutoMode){
                return this.iJoinMark != 1;
            }
            if (this.oForm.isSubmiting || this.hasPredictedAll) {
                return true; // 正在运行中，禁用
            }
            return false;
        },
        // ↓ 自动模式： 返回 true 表示，已经预言了所有钻石的位置 
        hasPredictedAll() {
            let {isAutoMode, round, count} = this;
            const hasReached = (round.prediction.length + count) >=  25;
            return (isAutoMode && hasReached);
        },
        // ↓ 计算是否要禁用下注按钮
        disabledBetBtn(){
            const {isAutoMode, iJoinMark } = this;
            const hasPrediction = this.prediction.length > 0;
            if (isAutoMode) {
                // ↓ 没选则禁用
                if (!hasPrediction) return true; 
                if (this.plan2StopAutoBetting) {
                    return iJoinMark > 0; // 计划关停，且还在执行，显示为禁用 
                }
                return false;
            }
            return iJoinMark == 1 && !hasPrediction;
        },
        // ↓ 计算是否禁用 ranger
        disabledRanger(){
            const {isAutoMode, iJoinMark, prediction, oForm} = this;
            if (isAutoMode) {
                return oForm.isSubmiting; // 禁用
            }else{
                return iJoinMark == 1; // 禁用
            }
        },
        // ↓ 下注按钮文字
        aBetBtnWords(){
            const {t: $tFn} = useNuxtApp().$i18n;
            const {isAutoMode, iJoinMark, oUserStore} = this;
            const aResult = ['', ''];
            aResult[0] = (()=>{
                if (isAutoMode){
                    // console.log("this.oForm.isSubmiting", this.oForm.isSubmiting);
                    if (this.oForm.isSubmiting) {
                        return $tFn(this.oGlobal.autoModeBtnWords.stop);
                    }
                    return $tFn(this.oGlobal.autoModeBtnWords.start);
                }
                // ↑自动模式 - ↓手动
                if (iJoinMark === 1) {
                    return $tFn('game.cashout').toUpperCase();
                }
                return $tFn('game.bet');
            })();
            if (!isAutoMode && iJoinMark === 1 && this.fMoneyCashOut){
                aResult[1] = String(this.fMoneyCashOut);
            }
            if (isAutoMode){
                aResult[1] = this.autoOption.sRoundsRest;
            }
            return aResult;
        },
        // ↓ 用户期待的提现金额 
        expectedReward(){
            if (!this.coeffs.length) return 0;
            const iFound = this.aDiaondFound.length;
            const idx = (
                (iFound > 0)
                ? (iFound - (this.isAutoMode ? 1 : 0))
                : 0
            );
            const fMaxMulti = this.coeffs[idx];
            if (!fMaxMulti) return 0; 
            import.meta.dev && console.log('预期取现倍数：', fMaxMulti); 
            const formAmount =  Number(this.oForm.amount);
            const fResult = formAmount * fMaxMulti;
            return fResult;
        },
    },
    // ------------------------------------------------------------------------------------------
    watch: {
        expectedReward(newVal){
            // 有必要延时 
            setTimeout(()=>{
                showTips4BadAmountIfNeeded(this.expectedReward);
            }, 500);
        },
        isShowAnimation(isShowAnim){
            // console.log('isShowAnim =', isShowAnim);
            if (isShowAnim) {
                this.showStepsAnimation();
                return;
            }
            (this.oStepsAnim as any).live = false; // 关闭动画
        },
        "round.prediction": {
            deep: true,
            handler() {
                this.check();
            },
        },
        "round.count": {
            deep: true,
            handler() {
                this.initTheGame();
            },
        },
        isAutoMode(bNew, bOld){
            if (bNew == bOld) return;
            console.log('自动模式:', bNew);
            // ↓ 清空定时器（意在放弃稍后重置舞台，“现在” 就调用 initTheGame() 重置它！）
            clearTimeout(this.timer4CloseResult);
            this.initTheGame();
        },
        // ↓ 加载进行中的未完成的游戏 
        'oJoinStateStore.lastRound': {
            deep: true,
            immediate: true,
            handler(oLastRound) {
                const {length} = Object.keys(oLastRound || {}); 
                if (import.meta.server || !length) return; 
                if (oLastRound.hash == this.oLastRoundGame.hash) {
                    return; // 返回，防止重复加载 
                }
                // const test01 = Math.random() > 0.4;
                // console.log('💘💘💘 Stop loading? ==>', test01);
                // console.log('💘💘💘 Stop loading? ==>', test01);
                // console.log('💘💘💘 Stop loading? ==>', test01);
                // console.log('💘💘💘 Stop loading? ==>', test01);
                // if (test01) return;
                const oRound = deepCopy(oLastRound);
                this.oLastRoundGame = oRound;
                this.oForm.amount = oRound.amount;
                this.loadOngoingGame(oRound);
                showLastRoundLoadedInfo();
                this.oJoinStateStore.gameRunning = true; // 设为“游戏进行中” 
            },
        },
    },
    mounted(){
        useBettingToolkit(this.oForm); // 设定默认下注金额 
        const {stopInfinity, startInfinity} = useAutoBetToolKit(
            this.oForm, // 下注的表单
            this.autoModeSubmit as any,
        );
        Object.assign(this, {
            stopInfinity,
            startInfinity,
        });
        this.check();
        this.showStepsAnimation();
    },
    beforeUnmount(){
        // console.log("beforeUnmount mines 👽", );
        // ↓ 关闭动画 
        (this.oStepsAnim as any).live = false;
        this.oMusic.toDestory(); 
    },
    methods:{ 
        ...oMethods,
    },
});


</script>


<style lang='scss' scoped src="./style/mines-controls.scss"></style>
<style lang='scss' scoped src="./style/mines-board.scss"></style>
<style lang='scss' scoped src="./style/mines-adding.scss"></style>
<style lang='scss' scoped src="./style/mines-background-steps.scss"></style>


